import { useEffect, useLayoutEffect, useRef } from 'react'

// Coalesce size changes outside ResizeObserver delivery. Layout writes inside
// the observer can cause a loop; resize and redraw together in the next frame.
export function useResizeObserver(ref, onResize) {
  const onResizeRef = useRef(onResize)
  useLayoutEffect(() => { onResizeRef.current = onResize })

  useEffect(() => {
    const el = ref.current
    if (!el) return
    let frame = null, latest
    const obs = new ResizeObserver(([entry]) => {
      latest = entry.contentRect
      if (frame !== null) return
      frame = requestAnimationFrame(() => {
        frame = null
        onResizeRef.current(latest)
      })
    })
    obs.observe(el)
    return () => {
      obs.disconnect()
      if (frame !== null) cancelAnimationFrame(frame)
    }
  }, [ref])
}
